document.addEventListener('DOMContentLoaded', () => {
    const vsliderContainers = document.querySelectorAll('.chr-desksld');

    vsliderContainers.forEach(vsliderContainer => {
        const vslider = new Swiper(vsliderContainer, {
            direction: 'vertical',
            updateOnWindowResize: true,
            loop: false,
            mousewheel: true,
            autoHeight: true,
            lazy: false,
            effect: 'fade',
            spaceBetween: 0,
            slidesPerView: 1,
            preventClicks: false,
            preventClicksPropagation: false,
            simulateTouch: false,
            pagination: false,
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const mobSliderCs = document.querySelectorAll('.chr-mobsld');

    mobSliderCs.forEach(mobSliderC => {
        const vslider = new Swiper(mobSliderC, {
            updateOnWindowResize: true,
            autoHeight: true,
            loop: false,
            slidesPerView: 1,
            effect: 'fade',
            spaceBetween: 0,
            slidesPerView: 1,
            preventClicks: false,
            preventClicksPropagation: false,
            simulateTouch: false,
            pagination: {
                el: mobSliderC.querySelector('.chr-dots'), 
                clickable: true,
            },
        });
    });
});



document.addEventListener("DOMContentLoaded", function() {
    const faqQuestions = document.querySelectorAll(".chr-faq-q");

    faqQuestions.forEach((question) => {
        question.addEventListener("click", function() {
            const thisAnswer = this.parentElement.querySelector(".chr-faq-a");
            const thisIcon = this.querySelector(".chr-faq-p, .chr-faq-m");
            const isOpen = thisAnswer.style.display === "block";

            document.querySelectorAll(".chr-faq-a").forEach((a) => {
                a.style.display = "none";
            });

            document
                .querySelectorAll(".chr-faq-q .chr-faq-p, .chr-faq-q .chr-faq-m")
                .forEach((icon) => {
                    icon.classList.remove("chr-faq-m");
                    icon.classList.add("chr-faq-p");
                });

            if (!isOpen) {
                thisAnswer.style.display = "block";
                thisIcon.classList.remove("chr-faq-p");
                thisIcon.classList.add("chr-faq-m");
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const productWrappers = document.querySelectorAll('.chr-mtxw');

    productWrappers.forEach(chrPMW => {
        const chrTxC = chrPMW.querySelector('.chr-mtx');
        const chrRMBtn = chrPMW.querySelector('.chr-rmbtn');

        if (chrTxC && chrRMBtn) {
            if (chrTxC.scrollHeight > chrTxC.clientHeight) {
                chrRMBtn.style.display = 'inline-block';

                chrRMBtn.addEventListener('click', () => {
                    chrTxC.classList.toggle('expanded');

                    if (chrTxC.classList.contains('expanded')) {
                        chrRMBtn.textContent = 'Lire moins';
                    } else {
                        chrRMBtn.textContent = 'Lire plus';
                    }
                });
            } else {
                chrRMBtn.style.display = 'none';
            }
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const imageLinks = document.querySelectorAll('a.chr-ptimage');

    imageLinks.forEach(link => {
        const img = link.querySelector('img');
        if (img && img.dataset.swimg) {
            const hoverSrc      = img.dataset.swimg;            
            const originalSrc   = img.src;

            link.addEventListener('mouseover', () => {
                img.src = hoverSrc;
            });
            link.addEventListener('mouseout', () => {
                img.src = originalSrc;
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const chrprods = new Swiper('.chrprods', {
        updateOnWindowResize: true,
        autoHeight: true,
        loop: false,
        slidesPerView: 2,        
        spaceBetween: 10,
        pagination: false,
        navigation: {
            nextEl: '.chr-next',
            prevEl: '.chr-prev',
        },
        breakpoints: {
            300: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 20,
            }
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.chr-bnd-s');

    buttons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const containerScope = event.currentTarget.closest('.chr-bundle-box');            
            if (!containerScope) return;

            const bundleInfo = containerScope.querySelector('.chr-bundle-info');
            const bundleOpts = containerScope.querySelector('.chr-bundle-opts');
            
            // This button goes back to the product list
            if (bundleInfo && bundleOpts) {
                bundleInfo.classList.add('hidden');
                bundleOpts.classList.remove('hidden');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Initialize: set all "Select Scent" buttons as disabled
    const allBundleBoxes = document.querySelectorAll('.chr-bundle-box');
    const bundleAddAllBtn = document.getElementById('bundle-add-all');
    
    allBundleBoxes.forEach(box => {
        const selectBtn = box.querySelector('.chr-bnd-sel');
        if (selectBtn) {
            selectBtn.classList.add('disabled');
        }
    });
    
    // Initialize bundle add all button as disabled
    if (bundleAddAllBtn) {
        bundleAddAllBtn.classList.add('disabled');
    }
    
    // Function to check if all 3 boxes have selected products
    function checkBundleCompletion() {
        if (!bundleAddAllBtn) return;
        
        // Get only visible boxes (desktop OR mobile, not both)
        const desktopBoxes = document.querySelectorAll('.chrdesk .chr-bundle-w .chr-bundle-box');
        const mobileBoxes = document.querySelectorAll('.chrmob .bundlesw .chr-bundle-box');
        
        // Determine which set is visible
        let visibleBoxes = [];
        if (window.innerWidth > 768) {
            visibleBoxes = Array.from(desktopBoxes);
        } else {
            visibleBoxes = Array.from(mobileBoxes);
        }
        
        let selectedCount = 0;
        
        visibleBoxes.forEach(box => {
            const selectedProduct = box.querySelector('.chr-poptions a.active');
            if (selectedProduct) {
                selectedCount++;
            }
        });
        
        // Enable button only if we have 3 selected products
        if (selectedCount >= 3) {
            bundleAddAllBtn.classList.remove('disabled');
        } else {
            bundleAddAllBtn.classList.add('disabled');
        }
    }

    const optionContainers = document.querySelectorAll('.chr-poptions');

    optionContainers.forEach(container => {
        const links = container.querySelectorAll('a');
        const parentBox = container.closest('.chr-bundle-box');
        const selectBtn = parentBox ? parentBox.querySelector('.chr-bnd-sel') : null;
        const previewImg = parentBox ? parentBox.querySelector('.chr-preview-img') : null;

        links.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                
                // Remove active class from all links in this container
                links.forEach(item => {
                    item.classList.remove('active');
                });
                
                // Add active class to clicked link
                event.currentTarget.classList.add('active');
                
                // Enable the select button
                if (selectBtn) {
                    selectBtn.classList.remove('disabled');
                }
                
                // Update preview image
                const productImage = event.currentTarget.getAttribute('data-product-image');
                if (productImage && previewImg) {
                    previewImg.src = productImage;
                }
                
                // Preload the product image for instant display later
                if (productImage) {
                    const img = new Image();
                    img.src = productImage;
                }
                
                // Check if all 3 boxes are now complete
                checkBundleCompletion();
            });
        });
    });
    
    // Re-check on window resize
    window.addEventListener('resize', checkBundleCompletion);
    
    // Handle bundle add all button click
    if (bundleAddAllBtn) {
        bundleAddAllBtn.addEventListener('click', async function(event) {
            event.preventDefault();
            
            // Don't do anything if disabled
            if (this.classList.contains('disabled')) {
                return;
            }
            
            // Get all selected products from visible boxes only
            const desktopBoxes = document.querySelectorAll('.chrdesk .chr-bundle-w .chr-bundle-box');
            const mobileBoxes = document.querySelectorAll('.chrmob .bundlesw .chr-bundle-box');
            
            // Determine which set is visible
            let visibleBoxes = [];
            if (window.innerWidth > 768) {
                visibleBoxes = Array.from(desktopBoxes);
            } else {
                visibleBoxes = Array.from(mobileBoxes);
            }
            
            const selectedVariants = [];
            
            visibleBoxes.forEach(box => {
                const selectedProduct = box.querySelector('.chr-poptions a.active');
                if (selectedProduct) {
                    const variantId = selectedProduct.getAttribute('data-variant-id');
                    if (variantId) {
                        selectedVariants.push(variantId);
                    }
                }
            });
            
            // Make sure we have exactly 3 products
            if (selectedVariants.length < 3) {
                return;
            }
            
            // Create and add loader
            const loader = document.createElement('div');
            loader.className = 'chr-bundle-loader';
            loader.innerHTML = '<div class="chr-bundle-loader__bar"><div class="chr-bundle-loader__line"></div></div>';
            
            // Store original dimensions and content
            const originalText = this.textContent;
            const originalHeight = this.offsetHeight;
            const originalWidth = this.offsetWidth;
            
            // Set fixed dimensions before hiding text
            this.style.minHeight = originalHeight + 'px';
            this.style.minWidth = originalWidth + 'px';
            
            // Hide button text and add loader
            this.textContent = '';
            this.appendChild(loader);
            this.style.pointerEvents = 'none';
            
            try {
                // Add all products to cart using Shopify Cart API
                const items = selectedVariants.map(id => ({
                    id: id,
                    quantity: 1
                }));
                
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ items })
                });
                
                if (!response.ok) {
                    throw new Error('Failed to add items to cart');
                }
                
                // Trigger cart update event for theme
                document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
                
                // Open quick cart and remove loader after a delay
                setTimeout(() => {
                    const cartTrigger = document.querySelector('[data-js-cart-icon="bag"], [data-cart-open], [aria-controls*="quick-cart"], [href="#cart-drawer"]');
                    if (cartTrigger) {
                        cartTrigger.click();
                    }
                    
                    // Remove loader and restore button after cart opens
                    setTimeout(() => {
                        if (loader && loader.parentNode) {
                            loader.remove();
                        }
                        this.textContent = originalText;
                        this.style.minHeight = '';
                        this.style.minWidth = '';
                        this.style.pointerEvents = '';
                    }, 500);
                }, 300);
                
            } catch (error) {
                console.error('Error adding bundle to cart:', error);
                alert('There was an error adding the bundle to cart. Please try again.');
                
                // Restore button on error
                if (loader && loader.parentNode) {
                    loader.remove();
                }
                this.textContent = originalText;
                this.style.minHeight = '';
                this.style.minWidth = '';
                this.style.pointerEvents = '';
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const closeButtons = document.querySelectorAll('.chr-bnd-sel');

    closeButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            
            // Check if button is disabled
            if (button.classList.contains('disabled')) {
                return;
            }
            
            const containerScope = event.currentTarget.closest('.chr-bundle-box');
            
            if (!containerScope) return; 

            const bundleInfo = containerScope.querySelector('.chr-bundle-info');
            const bundleOpts = containerScope.querySelector('.chr-bundle-opts');
            
            // Get selected product data
            const selectedProduct = bundleOpts.querySelector('.chr-poptions a.active');
            
            if (bundleInfo && bundleOpts && selectedProduct) {
                // Get product data from data attributes
                const productImage = selectedProduct.getAttribute('data-product-image');
                const productScent = selectedProduct.getAttribute('data-product-scent');
                const productShortTitle = selectedProduct.getAttribute('data-product-short-title');
                const productVolume = selectedProduct.getAttribute('data-product-volume');
                const productPrice = selectedProduct.getAttribute('data-product-price');
                const variantId = selectedProduct.getAttribute('data-variant-id');
                
                // Populate bundle info
                const imgElement = bundleInfo.querySelector('img');
                const h4Element = bundleInfo.querySelector('h4');
                const pElements = bundleInfo.querySelectorAll('p');
                const buyButton = bundleInfo.querySelector('.chr-bnd-buy');
                
                if (imgElement) imgElement.src = productImage;
                if (h4Element) h4Element.textContent = productScent;
                
                // First p: short title + volume
                if (pElements[0]) {
                    let titleText = productShortTitle;
                    if (productVolume) {
                        titleText += ' ' + productVolume;
                    }
                    pElements[0].textContent = titleText;
                }
                
                // Second p: price
                if (pElements[1]) {
                    pElements[1].textContent = productPrice;
                }
                
                // Store variant ID on buy button for later use
                if (buyButton && variantId) {
                    buyButton.setAttribute('data-variant-id', variantId);
                }
                
                // Hide options, show info
                bundleOpts.classList.add('hidden');
                bundleInfo.classList.remove('hidden');
            }
        });
    });
});

// Handle individual product "Ajouter au panier" button
document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', async function(event) {
        const buyButton = event.target.closest('.chr-bnd-buy');
        if (!buyButton) return;
        
        event.preventDefault();
        
        const variantId = buyButton.getAttribute('data-variant-id');
        if (!variantId) {
            console.error('No variant ID found on button');
            return;
        }
        
        // Add loading state
        buyButton.classList.add('loading');
        buyButton.style.pointerEvents = 'none';
        const originalText = buyButton.textContent;
        
        try {
            // Add product to cart using Shopify Cart API
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            });
            
            if (!response.ok) {
                throw new Error('Failed to add item to cart');
            }
            
            // Trigger cart update event for theme
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
            
            // Open quick cart after a small delay
            setTimeout(() => {
                const cartTrigger = document.querySelector('[data-js-cart-icon="bag"], [data-cart-open], [aria-controls*="quick-cart"], [href="#cart-drawer"]');
                if (cartTrigger) {
                    cartTrigger.click();
                }
            }, 300);
            
        } catch (error) {
            console.error('Error adding product to cart:', error);
            alert('There was an error adding the product to cart. Please try again.');
        } finally {
            // Remove loading state
            buyButton.classList.remove('loading');
            buyButton.style.pointerEvents = '';
            buyButton.textContent = originalText;
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const sliderlk = document.querySelectorAll('.sliderlk');

    sliderlk.forEach(sliderlks => {
        const slider = new Swiper(sliderlks, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerView: 1,
            preventClicks: false,
            preventClicksPropagation: false,
            simulateTouch: false,
            navigation: {
                nextEl: '.chr-next',
                prevEl: '.chr-prev',
            },
            pagination: false, 
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const seeMoreButtons = document.querySelectorAll('.chr-pgrid-sm');

    seeMoreButtons.forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            const container = this.closest('.chr-pgrid-w');            
            if (container) {
                const contentInfo = container.querySelector('.chr-pgrid-i');
                if (contentInfo) {
                    contentInfo.style.display = 'block';
                }
                this.style.display = 'none';
            }
        });
    });
});



document.addEventListener('DOMContentLoaded', () => {
    const bundlesw = document.querySelectorAll('.bundlesw');

    bundlesw.forEach(bundlesws => {
        const bundles = new Swiper(bundlesws, {
            loop: true,
            slidesPerView: 1.4,
            centeredSlides: true,
            spaceBetween: 15,
            preventClicks: false,
            preventClicksPropagation: false,
            simulateTouch: false,
            navigation: {
                nextEl: '.chr-next',
                prevEl: '.chr-prev',
            },
            pagination: false, 
        });
    });
});


document.addEventListener('DOMContentLoaded', () => {
    const tabsWrapper = document.querySelector('#chr_tabs_1');

    if (!tabsWrapper) return;
    
    tabsWrapper.addEventListener('click', (event) => {
        const clickedLink = event.target.closest('a[data-tog]');

        if (clickedLink) {
            event.preventDefault();
            const targetClassName = clickedLink.getAttribute('data-tog');

            tabsWrapper.querySelectorAll('a[data-tog]').forEach(link => {
                link.classList.remove('active');
            });

            document.querySelectorAll('[class^="chrptabs_"]').forEach(pane => {
                pane.classList.remove('active');
            });

            clickedLink.classList.add('active');
            
            document.querySelectorAll(`.${targetClassName}`).forEach(pane => {
                pane.classList.add('active');
            });

            const activeSwiperContainer = document.querySelector(`.${targetClassName} .swiper`);
            if (activeSwiperContainer && typeof Swiper !== 'undefined') {
                const swiperInstance = activeSwiperContainer.swiper;
                if (swiperInstance) {
                    swiperInstance.update();
                }
            }
        }
    });

    const initialActiveLink = tabsWrapper.querySelector('a.active');    
    if (initialActiveLink) {
        const initialTarget = initialActiveLink.getAttribute('data-tog');
        document.querySelectorAll(`.${initialTarget}`).forEach(pane => {
            pane.classList.add('active');
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const tabsWrapper2 = document.querySelector('#chr_tabs_2');

    if (!tabsWrapper2) return;
    
    tabsWrapper2.addEventListener('click', (event) => {
        const clickedLink2 = event.target.closest('a[data-let]');

        if (clickedLink2) {
            event.preventDefault();
            const targetClassName2 = clickedLink2.getAttribute('data-let');

            tabsWrapper2.querySelectorAll('a[data-let]').forEach(link2 => {
                link2.classList.remove('active');
            });

            document.querySelectorAll('[class^="chrletabs_"]').forEach(pane2 => {
                pane2.classList.remove('active');
            });

            clickedLink2.classList.add('active');
            
            document.querySelectorAll(`.${targetClassName2}`).forEach(pane2 => {
                pane2.classList.add('active');
            });

            const activeSwiperContainer2 = document.querySelector('.chrprods');
            if (activeSwiperContainer2 && typeof Swiper !== 'undefined') {
                const swiperInstance2 = activeSwiperContainer2.swiper;
                if (swiperInstance2) {
                    swiperInstance2.update();
                }
            }
        }
    });

    const initialActiveLink2 = tabsWrapper2.querySelector('a.active');    
    if (initialActiveLink2) {
        const initialTarget2 = initialActiveLink2.getAttribute('data-tog');
        document.querySelectorAll(`.${initialTarget2}`).forEach(pane2 => {
            pane2.classList.add('active');
        });
    }
});

// ============================================
// Universal Add-to-Cart Handler pentru Gala LP
// ============================================
(function() {
    function getFormFromButton(btn) {
        const form = btn.closest('form');
        return (form && form.querySelector('input[name="id"]')) ? form : null;
    }

    async function addToCartWithForm(form, btn) {
        const fd = new FormData(form);
        const variantId = fd.get('id');
        
        if (!variantId || !/^\d+$/.test(String(variantId))) {
            console.error('[Gala2 ATC] Invalid variant ID');
            return;
        }

        // Add loading state
        if (btn) {
            btn.disabled = true;
            btn.setAttribute('aria-busy', 'true');
            btn.classList.add('loading');
        }

        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams(fd).toString()
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.description || 'Failed to add to cart');
            }

            // Trigger theme's cart update event
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
            
            // Open minicart after a delay to allow refresh
            setTimeout(() => {
                const cartTrigger = document.querySelector('[data-js-cart-icon="bag"], [data-cart-open], [aria-controls*="quick-cart"], [href="#cart-drawer"]');
                if (cartTrigger) {
                    cartTrigger.click();
                }
            }, 300);

        } catch (error) {
            console.error('[Gala2 ATC] Error:', error);
            alert('Error adding product to cart. Please try again.');
        } finally {
            // Remove loading state
            if (btn) {
                btn.disabled = false;
                btn.removeAttribute('aria-busy');
                btn.classList.remove('loading');
            }
        }
    }

    // Handler pentru click pe butoane .chr-atc și .chr-btn (exclude bundle buttons care au propriul handler)
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.chr-atc, .chr-btn');
        
        // Skip bundle buy buttons - they have their own handler
        if (!btn || btn.classList.contains('chr-bnd-buy')) return;
        
        // Skip bundle add-all button - it has its own handler
        if (btn.classList.contains('chr-bundle-add-all')) return;
        
        const form = getFormFromButton(btn);
        if (!form) return;

        e.preventDefault();
        e.stopPropagation();
        addToCartWithForm(form, btn);
    }, true);

    // Handler pentru submit pe formulare (backup)
    document.addEventListener('submit', function(e) {
        const form = e.target.closest('form');
        if (!form) return;
        
        const btn = form.querySelector('.chr-atc, .chr-btn');
        if (!btn) return;
        
        // Skip bundle buttons
        if (btn.classList.contains('chr-bnd-buy') || btn.classList.contains('chr-bundle-add-all')) return;

        e.preventDefault();
        e.stopPropagation();
        addToCartWithForm(form, btn);
    }, true);
})();